import { render, staticRenderFns } from "./category_table.vue?vue&type=template&id=7181df28&"
import script from "./category_table.vue?vue&type=script&lang=js&"
export * from "./category_table.vue?vue&type=script&lang=js&"
import style0 from "./category_table.vue?vue&type=style&index=0&id=7181df28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports